export default {
    fields: {
        name: {
            label: 'Название',
            placeholder: 'Введите название компании',
        },
        pib: {
            label: 'ПИН',
            placeholder: 'Введите ПИН компании',
        },
        address: {
            label: 'Адрес',
            placeholder: 'Введите адрес',
        },
        subDomain: {
            label: 'Поддомен',
            placeholder: 'Введите поддомен',
        },
        city: {
            label: 'Город',
            placeholder: 'Выберите город',
        },
        country: {
            label: 'Страна',
            placeholder: 'Выберите страну',
            SERBIA: 'Сербия',
            BOSNIA: 'Босния и Герцеговина',
        },
        theme: {
            label: 'Тема',
            placeholder: 'Выберите тему',
        },
    },
    price_increase: 'Активация поддомена увеличит стоимость на {subdomainPrice}',
    subdomain_removal:
        'Ваш поддомен {subdomain} запланирован на удаление {removalDate} и будет удален первого числа следующего месяца',
    start_for_free: 'Начать бесплатно',
    choose_package: 'Выбрать пакет',
    update_company_heading: 'Вы уверены, что хотите обновить настройки вашей компании?',
    deactivate_company_heading: 'Вы уверены, что хотите деактивировать вашу компанию?',
    no_companies: 'У вас в настоящее время нет созданных компаний. Хотели бы вы сделать это сейчас?',
}
